<template>
  <div class="load">
    <div class="card white reverse">
      <div class="col ml-3 mr-3 center-items-y">
        <div class="mt-2 mb-2 row center-items red">
          <textarea
            v-model="message"
            rows="6"
            class="spacer"
            placeholder="Escribe un mensaje corto y claro ... "
            maxlength="120"
          ></textarea>
        </div>
        <div class="mb-3 row medium uppercased normal">
          <div
            @click.stop="sendMessage"
            :class="message != '' ? 'back1 isButton' : 'grey'"
            class="bizel height-50 spacer center-items theme pr-3 pl-3 col"
          >Enviar mensaje</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    message: ""
  }),
  methods: {
    sendMessage() {
      if (this.message != "") {
        axios
          .get(this.$store.getters.endpoint + "postMessage", {
            params: {
              license: this.$store.getters.profile.license,
              text: this.message
            }
          })
          .then(
            response => {
              this.$store.commit("closed");
              setTimeout(() => {
                alert("OK! Mensaje enviado a todos los usuarios.");
              }, 500);
            },
            error => {
              this.$store.commit("closed");
              setTimeout(() => {
                alert("ERROR! " + error.message);
              }, 500);
            }
          );
      }
    }
  }
};
</script>
<style scoped>
.load {
  position: fixed;
  z-index: 500;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  position: absolute;
  top: 0;
  width: 300px;
  /* height: 0px; */
  overflow: hidden;
  border-radius: 0 0 20px 20px;
}
.button-width {
  width: 150px;
}
</style>